/**
 * mira-bangumi-provider API
 * Management API for mira-bangumi-provider
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BgmSyncTaskState = 'Pending' | 'Running' | 'RetryScheduled' | 'AwaitingRefetch' | 'Paused' | 'Blocked' | 'Abandoned' | 'Exhausted' | 'Succeeded';

export const BgmSyncTaskState = {
    Pending: 'Pending' as BgmSyncTaskState,
    Running: 'Running' as BgmSyncTaskState,
    RetryScheduled: 'RetryScheduled' as BgmSyncTaskState,
    AwaitingRefetch: 'AwaitingRefetch' as BgmSyncTaskState,
    Paused: 'Paused' as BgmSyncTaskState,
    Blocked: 'Blocked' as BgmSyncTaskState,
    Abandoned: 'Abandoned' as BgmSyncTaskState,
    Exhausted: 'Exhausted' as BgmSyncTaskState,
    Succeeded: 'Succeeded' as BgmSyncTaskState
};

